'use es6';

import PortalIdParser from 'PortalIdParser';
import * as storage from 'reporting-data/lib/storage';
export const STORAGE_KEY = '@@reporting-reports:dismissed-banners';
export const getBannerId = report => {
  if (!report) {
    return '';
  }
  const messageKey = report.getIn(['deprecation', 'message'], '');
  return `${PortalIdParser.get()}:${messageKey}:${report.get('id', '')}`;
};
export const hasDismissedBanner = report => {
  const bannerId = getBannerId(report);
  const dismissed = storage.get(STORAGE_KEY) || [];
  return dismissed.includes(bannerId);
};
export const permanentlyDismissBanner = report => {
  const deprecation = report && report.get('deprecation');
  if (!deprecation || deprecation.get('type') !== 'SHOW_BANNER') {
    return;
  }
  const bannerId = getBannerId(report);
  const dismissed = storage.get(STORAGE_KEY) || [];
  if (!dismissed.includes(bannerId)) {
    storage.set(STORAGE_KEY, [bannerId, ...dismissed]);
  }
};